module.exports = __webpack_public_path__ + "img/horizontal_4_2_2.56e10d65.png";